import { useQuery } from '@tanstack/react-query'

import API from '../../../utils/api'

export const useFullCatalog = () => {
  const { data, isLoading, refetch, error } = useQuery(
    ['/games_catalog/list'],
    API.getGames,
    {
      staleTime: Infinity,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  )

  return {
    games: data?.data?.games || [],
    types: data?.data?.types || [],
    total: data?.data?.total ?? 0,
    isLoading,
    refetch,
    error,
  }
}
